var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKiiltoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.73 141.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#003c71;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.87,
    cy: 70.87,
    r: 70.87,
    transform: "translate(-29.35 70.87) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.72,57.32v5.41H91V84.38H85.09V62.73H78.32V57.32Zm-25.87,0H66V84.38H79.51V79H71.85ZM54.14,84.38h6V68.11h-6Zm6-27.06h-6v5.41h6ZM126,70.87a13.51,13.51,0,1,1-13.51-13.68A13.39,13.39,0,0,1,126,70.87Zm-6,0a7.52,7.52,0,1,0-7.51,7.83A7.49,7.49,0,0,0,120,70.87ZM36.54,63.51V57.32L22.05,66.86V57.32H16.19V84.38h5.86V73l3.77-2.47,5.61,13.82h6.31l-7-17.09Zm5.74,20.87h6V68.11h-6Zm6-27.06h-6v5.41h6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiiltoLogo);
export default __webpack_public_path__ + "static/media/kiilto_logo.d328955f6ef12455cc0303e7eac918a3.svg";
export { ForwardRef as ReactComponent };